import { Button, Card, Col, Container, Row } from "react-bootstrap";
import CoursePlan from "../../docs/VEL710RevisedCourseOutline.pdf";
import Background from "../../image/background9.jpg";
import DTiBrocher from "../../docs/DTI B10 Brochure.pdf";
export default function DesignThinking() {
    return(
        <>
        <Container fluid style={{background: "url(" + Background + ") no-repeat fixed center"}}>
        <Container>
            <Row className="justify-content-center section">
                <Col md="8" sm="12" className="image-over-section">
                    <h2 style={{textAlign:"center"}}>Design Thinking & Innovation</h2>
                    <p style={{textAlign:"center"}}><i>Ongoing: Batch 10 (March - August 2026)</i></p>
                    <p style={{textAlign:"center"}}>The IIT Delhi Design Thinking and Innovation (DTI) Programme is a 20-week online
programme designed to provide a comprehensive understanding of Design Thinking
principles and their real-world applications. Taught by esteemed faculty from IIT Delhi
and industry experts, and complemented by GenAI masterclasses, the programme
covers key methodologies, tools, and frameworks to help professionals develop
innovative solutions in dynamic business environments.</p>
                    <Button href={DTiBrocher} target="_blank">Course Brochure <i className="bi bi-box-arrow-up-right"></i></Button>
                </Col>
            </Row>
        </Container>
        </Container>

        <Container className="section">
                <h2>Course Structure</h2>
            <Row xs="1" sm="3" md="3">
                <Col>
                    <Card className="publications-list module">
                        <Card.Header>MODULE 1 : Introduction to Human-Centred Design (HCD)</Card.Header>
                        <Card.Body>
                            <Card.Text>
                                <ul>
                                    <li>The Paradox of Our Age</li>
                                    <li>The Principles of Co-Learning</li>
                                    <li>A Shift in Being</li>
                                    <li>What Design is Not?</li>
                                    <li>What is Design?</li>
                                    <li>Key Concepts of Design</li>
                                    <li>A Simplified Understanding of Design</li>
                                    <li>A Simplified Process of Design</li>
                                </ul>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>

                <Col>
                    <Card className="publications-list module">
                        <Card.Header>MODULE 2 : HCD and Innovation</Card.Header>
                        <Card.Body>
                            <Card.Text>
                                <ul>
                                    <li>Understanding Purpose</li>
                                    <li>Letting Go of What Holds Us Back</li>
                                    <li>What is Creativity?</li>
                                    <li>Thinking Differently</li>
                                    <li>Basic Rules of Design Thinking</li>
                                    <li>The Creativity Heart Set</li>
                                    <li>Everyone is a Designer</li>
                                    <li>Double Diamond Framework and Abstract-Tangible Cycle</li>
                                </ul>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
                <Col>
                    <Card className="publications-list module">
                        <Card.Header>MODULE 3 : Context, Environment and Users</Card.Header>
                        <Card.Body>
                            <Card.Text>
                                <ul>
                                    <li>Review - Double Diamond and Abstract-Tangible Cycle</li>
                                    <li>Ethnographic, Participatory & Evaluative Research</li>
                                    <li>Clean Team Case Study</li>
                                    <li>Effective Research for HCD</li>
                                    <li>Design in the World</li>
                                    <li>User Context</li>
                                    <li>Mis-design Around Us</li>
                                    <li>Who are your Users?</li>
                                    <li>Visible and Invisible Users</li>
                                    <li>Hybrid Model of Research</li>
                                    <li>Redefining the Problem</li>
                                </ul>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>

                <Col>
                    <Card className="publications-list module">
                        <Card.Header>MODULE 4 : Identifying User Needs</Card.Header>
                        <Card.Body>
                            <Card.Text>
                                <ul>
                                    <li>Empathy Map Canvas</li>
                                    <li>Hearing the Unsaid</li>
                                    <li>Designing for Extreme Users</li>
                                    <li>Why is Creativity Becoming More Important?</li>
                                    <li>PLATOS Case Study</li>
                                    <li>Understanding Uncommunicative Users</li>
                                    <li>Waterless Urinal Case Study</li>
                                    <li>The Changing Wishlist</li>
                                    <li>The User Value Proposition</li>
                                    <li>Doing the Homework - Ecosystem</li>
                                    <li>Needs vs. Wants</li>
                                </ul>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>

                <Col>
                    <Card className="publications-list module">
                        <Card.Header>MODULE 5 : Ideation and Immersion</Card.Header>
                        <Card.Body>
                            <Card.Text>
                                <ul>
                                    <li>Creative Ideation and Pattern Recognition</li>
                                    <li>Developing Creative Habits</li>
                                    <li>Creative Thinking Techniques</li>
                                    <li>SCAMPER</li>
                                    <li>Brainstorming Tools</li>
                                    <li>The Importance of True Immersion</li>
                                    <li>Immersive Learning</li>
                                    <li>Immersive Experience in the Design Process</li>
                                    <li>Mindful Design</li>
                                    <li>Automobile Design Process</li>
                                    <li>Design DNA and Mood Boards</li>
                                </ul>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>

                <Col>
                    <Card className="publications-list module">
                        <Card.Header>MODULE 6 : Storytelling and Visualisation</Card.Header>
                        <Card.Body>
                            <Card.Text>
                                <ul>
                                    <li>Stories vs Narrations</li>
                                    <li>Storytellers Across Time and Cultures</li>
                                    <li>Experimental Storytelling</li>
                                    <li>Storytelling in Research</li>
                                    <li>Rural Storytelling Case Study</li>
                                    <li>Storytelling in Design</li>
                                    <li>Brand Stories</li>
                                    <li>The Importance of Visuals and Visualisation</li>
                                    <li>Visualising Human Experiences</li>
                                    <li>Storyboarding or Image Boarding</li>
                                </ul>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>

                <Col>
                    <Card className="publications-list module">
                        <Card.Header>MODULE 7 : Iterative Design and Sustainability</Card.Header>
                        <Card.Body>
                            <Card.Text>
                                <ul>
                                    <li>Why Iterative Design?</li>
                                    <li>Iterative Design Process</li>
                                    <li>Waterless Urinal Cubicle Case Study</li>
                                    <li>Research as a Tool</li>
                                    <li>Handloom Case Study</li>
                                    <li>Types of Sustainability</li>
                                    <li>Sustainability in Action</li>
                                    <li>Immersive Research Case Study</li>
                                    <li>Nonimmersive Research Case Study</li>
                                </ul>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>

                <Col>
                    <Card className="publications-list module">
                        <Card.Header>MODULE 8 : MVP and NPD</Card.Header>
                        <Card.Body>
                            <Card.Text>
                                <ul>
                                    <li>What is Minimum Value?</li>
                                    <li>Identifying the MVP</li>
                                    <li>Rural ATM Case Study</li>
                                    <li>Prototyping as a Tool</li>
                                    <li>Critical Stages in Prototypng</li>
                                    <li>Stages in New Product Development</li>
                                    <li>Types of Prototypes</li>
                                    <li>Case Study - Children during the COVID-19 Lockdown</li>
                                </ul>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>

                <Col>
                    <Card className="publications-list module">
                        <Card.Header>MODULE 9 : Agile Design and Data-Driven Innovation</Card.Header>
                        <Card.Body>
                            <Card.Text>
                                <ul>
                                    <li>What is Lean and Agile?</li>
                                    <li>Agile within Design</li>
                                    <li>Designing Agile Processes</li>
                                    <li>Electric Motor Case Study</li>
                                    <li>What is Data-Driven Innovation</li>
                                    <li>Data-Driven Innovation and Design</li>
                                    <li>ML Lifecycle vs. Design Lifecycle</li>
                                    <li>Generative Design and Nature-Inspired Computing</li>
                                </ul>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>

                <Col>
                    <Card className="publications-list module">
                        <Card.Header>MODULE 10 : Integrating Design, Technology and Business</Card.Header>
                        <Card.Body>
                            <Card.Text>
                                <ul>
                                    <li>Project Management Methodologies</li>
                                    <li>Scrum, Kanban, and Scrumban</li>
                                    <li>Example from UI/UX Industry</li>
                                    <li>Example from Finance Industry</li>
                                    <li>Customer Segmentation and Innovation</li>
                                    <li>Design and Systems Thinking</li>
                                    <li>Design and Systems Thinking Working Harmoniously</li>
                                    <li>Business Design</li>
                                    <li>Contributions of a Business Designer</li>
                                </ul>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>

                <Col>
                    <Card className="publications-list module">
                        <Card.Header>MODULE 11 : Innovation Project Lifecycle and
                        Innovation Management Tools</Card.Header>
                        <Card.Body>
                            <Card.Text>
                                <ul>
                                    <li>Lean Management Principles</li>
                                    <li>Logical and Creative Thinking</li>
                                    <li>Product Implementation Lifecycle</li>
                                    <li>Types of Innovation</li>
                                    <li>Roadblocks to Idea Generation and Implementation</li>
                                    <li>Strategies for Whole Brain Thinking</li>
                                    <li>Design Management</li>
                                </ul>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>

                <Col>
                    <Card className="publications-list module">
                        <Card.Header>MODULE 12 : Innovation Strategies and Taking Ideas to Market</Card.Header>
                        <Card.Body>
                            <Card.Text>
                                <ul>
                                    <li>Entrepreneurship in Organisations</li>
                                    <li>Innovation Strategies</li>
                                    <li>Frugal Innovation Strategies</li>
                                    <li>Challenging Assumptions</li>
                                    <li>Safeguarding Your Innovation</li>
                                </ul>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>

                <Col>
                    <Card className="publications-list module">
                        <Card.Header>MODULE 13 : Designing for Change</Card.Header>
                        <Card.Body>
                            <Card.Text>
                                <ul>
                                    <li>Elements of Organisational Culture</li>
                                    <li>Organisational Change Through Design</li>
                                    <li>Storytelling for Organisational Transformation</li>
                                    <li>Context Canvas</li>
                                    <li>Defining the Challenge - Technical vs Adaptive</li>
                                    <li>What are Rituals?</li>
                                    <li>Co-designing Rituals</li>
                                    <li>Celebrating Rituals and Sustaining Rituals</li>
                                </ul>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>

                <Col>
                    <Card className="publications-list module">
                        <Card.Header>MODULE 14 : Design for Leading</Card.Header>
                        <Card.Body>
                            <Card.Text>
                                <ul>
                                    <li>What Leadership is Not</li>
                                    <li>Leadership and Commitment</li>
                                    <li>The Triad of Leadership</li>
                                    <li>Operating from your Being</li>
                                    <li>Leading with Purpose</li>
                                    <li>Inspiring People</li>
                                    <li>The World is Your Playground</li>
                                </ul>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
        </>
        )
    }